import React from 'react'

const PathNotFound = () => {
  return (
    <div className='w-full flex-col flex items-center justify-center h-[90vh] bg-[#858585'>
     <h1 className='text-[3rem] font-bold text-black '>404 Not Found</h1>
     <h1 className='text-[3rem] font-bold text-black '>Page Will Be Added Soon</h1>
    </div>
  )
}

export default PathNotFound